import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Analyse } from 'src/app/domain/Analyse/analyse';
import { AnalyseStatut } from 'src/app/domain/Analyse/enum/analyse-statut';
import { IBMRAnalyse } from 'src/app/domain/IBMR/IBMR-analyse';
import { Taxon } from 'src/app/domain/IBMR/IBMR-taxon';
import { User } from 'src/app/domain/planning/user';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { AnalyseService } from 'src/app/services/analyse-service';
import { UserService } from 'src/app/services/user-service';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { SplitTaxonBoxComponent } from 'src/app/tools/ui/split-taxon-box/split-taxon-box.component';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-analyse-ibmr',
    templateUrl: './analyse-ibmr.component.html',
    styleUrl: './analyse-ibmr.component.scss'
})
export class AnalyseIbmrComponent {
    AnalyseStatut = AnalyseStatut;
    @ViewChild('analyste') analyste: ElementRef<HTMLInputElement>;
    public model: IBMRAnalyse = new IBMRAnalyse();
    UR1TaxonList: Taxon[] = []
    UR2TaxonList: Taxon[] = []

    public AllUserList: User[] = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    addOnBlur = true;
    selectable = true;

    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save',
            },
            {
                Id: 1,
                Text: undefined,
                Icon: 'done',
            },
            {
                Id: 2,
                Text: undefined,
                Icon: 'history',
            },
        ];

    constructor(
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private snackBar: MatSnackBar,
        private analysisService: AnalyseService,
        private userService: UserService) {

    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        this.getAnalyseFromServer();
        this.getAvailableUserList();
    }

    getAnalysisStatusName(type: number) {
        return StringConverter.getAnalysisStatusName(type);
    }

    openTaxonIdentifyBox(taxon: Taxon) {
        const dialogRef = this.dialog.open(SplitTaxonBoxComponent, {
            data: {
                taxon: taxon,
                analyseCode: this.model.Code
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAnalyseFromServer()
            }
        });
    }

    checkAndWarnForExistingAnalysis() {

        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Voulez-vous reinitialiser l\'analyse ?';
        m.WithReason = false;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ConfirmBoxModel) => {
            if (result) {
                this.resetAnalyse();
            }
        });
    }

    // Analyser - analyste
    removeAnalyser(user: User): void {
        const index = this.model.AnalyserList.indexOf(user);

        if (index >= 0) {
            this.model.AnalyserList.splice(index, 1);
        }
    }

    selectedAnalyser(event: MatAutocompleteSelectedEvent) {
        this.model.AnalyserList.push(this.AllUserList.find(u => u.Fullname === event.option.viewValue));
        this.analyste.nativeElement.value = '';
    }

    getAnalyseFromServer() {
        this.analysisService.getAnalyseIBMRByCode(this.route.snapshot.params.interventionCode).subscribe(x => {
            this.model = x;
            this.UR1TaxonList = this.model.TaxonList.filter(x => x.NumeroPhase === 1)
            this.UR2TaxonList = this.model.TaxonList.filter(x => x.NumeroPhase === 2)
        });
    }

    getAvailableUserList() {
        this.userService.getAll().subscribe(x => this.AllUserList = x);
    }

    toggleValidation() {
        this.analysisService.finishAnalyse(this.model.Code).subscribe(x => {
            if (x) {
                if (this.model.Status === AnalyseStatut.Done) {
                    NotificationManager.handleSuccess(`En cours d'analyse`, this.snackBar);
                    this.model.Status = AnalyseStatut.InProgress;
                } else {
                    NotificationManager.handleSuccess(`Analyse terminée`, this.snackBar);
                    this.model.Status = AnalyseStatut.Done;
                }
            }
        });
    }

    resetAnalyse() {
        this.analysisService.reset(this.model.Code).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Analyse réinitialisée', this.snackBar)
                this.getAnalyseFromServer();
            }
        })
    }
    
    save() {
        this.analysisService.update(this.model).subscribe(x => {
            NotificationManager.handleSuccess(`Analyse mise à jour`, this.snackBar);
        });
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save();
                break;
            case 1:
                this.toggleValidation();
                break;
            case 2:
                this.checkAndWarnForExistingAnalysis();
                break;
        }
    }
}
